module.exports = __webpack_public_path__ + "img/tron.760fdf0a.png";